<template>
    <div class="customer-detail-modal">
        <el-row>
            <el-col :span="14" class="text-md-left">
                <span class="text-bold">ข้อมูลปัจจุบัน</span>
            </el-col>
            <el-col :span="10">
                <div class="clearfix customer-text-left">
                    <el-button type="primary" icon="el-icon-plus" @click="createQrPayment()">สร้างแพ็กเกจ</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="text-md-left">
                <span class="text-bold">รายละเอียดแพ็กเกจ</span>
            </el-col>
            <el-col :span="8" class="text-md-left my-16">
                <div>
                    <span>แพ็กเกจ</span>
                </div>
                <div>
                    <span>ระยะเวลาการใช้งาน</span>
                </div>
                <div>
                    <span>ยอดรวมที่ต้องชำระ</span>
                </div>
            </el-col>
            <el-col :span="16" class="text-md-left my-16">
                <div>
                    <div v-if="historyDetail.subscriptionName">{{historyDetail.subscriptionName}} Package แบบ{{historyDetail.subscriptionPlan ? convertEnumSubscription(historyDetail.subscriptionPlan) : ''}}</div>
                    <div v-else>-</div>
                </div>
                <div>
                    <span v-if="historyDetail.cycles">{{historyDetail.cycles}} เดือน</span>
                    <span v-else>-</span>
                </div>
                <div>
                    <span v-if="historyDetail.netPriceAmount">{{numberWithCommas(historyDetail.netPriceAmount)}} บาท</span>
                    <span v-else>-</span>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" class="text-md-left">
                <span class="text-bold">QR Code สำหรับชำระเงิน</span>
            </el-col>
            <el-col :span="24">
                <el-row type="flex" align="middle" justify="center" class="my-16">
                    <div v-if="historyDetail.qrCodeImageUrl">
                        <qr-payment
                            :historyDetail.sync="historyDetail"
                            :detail.sync="detail"
                        ></qr-payment>
                    </div>
                    <el-row v-else type="flex" align="center" justify="center">
                        <div class="expired-qr-card">
                            <img class="expired-qr-img" src="@/assets/all-customer/expiredQR.png">
                        </div>
                    </el-row>
                </el-row>
            </el-col>
        </el-row>
        <el-divider></el-divider>
        <payment-history-table
            :detail.sync="detail"
            @onClickPaymentDetailDialog="$emit('onClickPaymentDetailDialog', $event)"
            @historyDetail="historyDetail = $event"
        ></payment-history-table>
    </div>
</template>

<script>
import QrPayment from '@/components/Customer/AllCustomer/QrPayment'
import PaymentHistoryTable from '@/components/Customer/AllCustomer/PaymentHistoryTable'
import { SUBSCRIPTION_TYPE_TH as enumSubscriptionTypeTh } from '@/constant/subscription.js'
import numberWithCommas from '@/mixins/formatDigitMixin'
export default {
    name: 'allCustomerDetail',
    mixins: [numberWithCommas],
    components: {
        QrPayment,
        PaymentHistoryTable
    },
    props: {
        detail: {
            type: Object,
            default: null
        }
    },
    data () {
        return {
            qrStatus: false,
            createQr: {
                dialog: false
            },
            historyDetail: []
        }
    },
    created () {
    },
    methods: {
        convertEnumSubscription (code) {
            return enumSubscriptionTypeTh[code]
        },
        createQrPayment () {
            this.$emit('onClickCreateQrDialog', { dialog: true, isCreate: true, userId: this.detail.userId })
        }
    }
}
</script>

<style lang="scss">
.customer-detail-modal{
    max-width: 1024px;
    margin: 8px 16px;
    .font-12 {
        font-size: 12px;
    }
    .my-8 {
        margin-top: 8px;
        margin-bottom: 8px;
    }
    .my-16 {
        margin-top: 16px;
        margin-bottom: 16px;
    }
    .labelForm {
        label {
            padding: unset !important;
        }
    }
    .expired-qr-card {
        height: 248px;
        width: 248px;
        background: #fff;
        padding: 12px;
        .expired-qr-img {
            width: 100%;
            height: auto;
        }
    }
}
</style>
<style lang="scss" scoped>
::v-deep .divider-dash {
    border: 1px dashed #D1D5E0;
    background-color: transparent !important;
}
</style>
